export enum Breakpoints {
  XS = 0,
  SM = 600,
  MD = 960,
  LG = 1200,
  XL = 1920,
}
